import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Settings } from '../../../core/models/app.settings.model';
import { AppSettings } from '../../../core/models/app.settings';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
})
export class NotFoundComponent {
  public settings: Settings;
  constructor(public appSettings: AppSettings, public router: Router) {
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {}

  goHome(): void {
    this.router.navigate(['/home']);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.settings.loadingSpinner = false;
    });
  }
}
